import React from 'react';
import { NavLink } from 'react-router-dom'

const mainMenu = [
  {
    "name": "Мониторинг",
    "key": "menu_control",
    "icon": "icon-eye",
    "submenu": [
      {
        "name": "Состояние системы",
        "key": "menu_status_kkc",
        "icon": "icon-graph",
        "action": "/sysstate",
        "rules": "rules"
      },
      {
        "name": "Связь с КНАП",
        "key": "menu_connect_knap",
        "icon": "icon-feed",
        "action": "/knapdata",
        "rules": "rules"
      },
      {
        "name": "Связь с ПУВ-СРК",
        "key": "menu_puvsrk",
        "icon": "icon-feed",
        "action": "/puvsrkstate",
        "rules": "rules"
      },
      {
        "name": "Связь с ЭРА",
        "key": "menu_era",
        "icon": "icon-feed",
        "action": "/erastate",
        "rules": "rules"
      },
      {
        "name": "Связь с КОНСУЛ",
        "key": "menu_konsul",
        "icon": "icon-feed",
        "action": "/konsulstate",
        "rules": "rules"
      },
      {
        "name": "Связь с ВИС",
        "key": "menu_vis",
        "icon": "icon-feed",
        "action": "/visstate",
        "rules": "rules"
      },
      {
        "name": "СПО ПУ-ЛСН",
        "key": "menu_connect_sch_pylsn",
        "icon": "icon-compass",
        "action": "/chpylsnconnect",
        "rules": "rules"
      },
      // {
      //   "name": "Связь с ВПУ ЛСН",
      //   "key": "menu_connect_vpylsn",
      //   "icon": "icon-flag",
      //   "action": "/vpylsnconnect",
      //   "rules": "rules"
      // }
    ]
  },
  {
    "name": "Конфигурирование",
    "key": "spr_conf",
    "icon": "icon-wrench",
    "submenu": [
      {
        "name": "ККС",
        "key": "menu_kks_stations",
        "icon": "icon-equalizer",
        "action": "/kksstations",
        "rules": "spr"
      },
      {
        "name": "МС",
        "key": "menu_mult_stations",
        "icon": "icon-equalizer",
        "action": "/mfuncstations",
        "rules": "spr"
      },
      {
        "name": "ПУВ-СРК",
        "key": "menu_pyvsrk_stations",
        "icon": "icon-equalizer",
        "action": "/pyvsrkstations",
        "rules": "spr"
      },
      {
        "name": "ЭРА",
        "key": "menu_era_stations",
        "icon": "icon-equalizer",
        "action": "/erastations",
        "rules": "spr"
      },
      {
        "name": "КОНСУЛ",
        "key": "menu_konsul_stations",
        "icon": "icon-equalizer",
        "action": "/konsulstations",
        "rules": "spr"
      },
      {
        "name": "ВИС",
        "key": "menu_vis_stations",
        "icon": "icon-equalizer",
        "action": "/visstations",
        "rules": "spr"
      },
      {
        "name": "СПО",
        "key": "menu_lsn",
        "icon": "icon-pin",
        "action": "/lsn",
        "rules": "spr"
      }
    ]
  },
  {
    "name": "Протоколирование",
    "key": "spr_protocols",
    "icon": "icon-folder-alt",
    "submenu": [
      {
        "name": "КНАП (карта)",
        "key": "knapmapdata",
        "icon": "icon-map",
        "action": "/knapmapdata",
        "rules": "spr"
      },
      {
        "name": "КНАП (таблица)",
        "key": "napdata",
        "icon": "icon-location-pin",
        "action": "/napdata",
        "rules": "spr"
      },
      {
        "name": "ККС",
        "key": "menu_kkcdata",
        "icon": "icon-doc",
        "action": "/kkcdata",
        "rules": "spr"
      },
      {
        "name": "МС (мощность)",
        "key": "menu_datams",
        "icon": "icon-book-open",
        "action": "/msdata",
        "rules": "spr"
      },
      {
        "name": "МС (поправки)",
        "key": "menu_datamsmod",
        "icon": "icon-book-open",
        "action": "/msdatamod",
        "rules": "spr"
      },
      {
        "name": "Работоспособность",
        "key": "menu_performance",
        "icon": "icon-list",
        "action": "/performance",
        "rules": "spr"
      },
      {
        "name": "Исправность",
        "key": "menu_serviceability",
        "icon": "icon-list",
        "action": "/serviceability",
        "rules": "spr"
      },
      {
        "name": "КОНСУЛ",
        "key": "menu_konsul",
        "icon": "icon-wallet",
        "action": "/konsul",
        "rules": "spr"
      },
      // {
      //   "name": "Данные СЧ ПУ ЛСН ",
      //   "key": "menu_sch_pylsn",
      //   "icon": "icon-list",
      //   "action": "/chpylsndata",
      //   "rules": "spr"
      // },
    ]
  },
  {
    "name": "Состояние серверов",
    "key": "menu_statusServ",

    "icon": "icon-organization",
    "submenu": [
      {
        "name": "Объекты доступа",
        "key": "menu_access_objects",
        "icon": "icon-grid",
        "action": "/access_objects",
        "rules": "rules"
      },
      {
        "name": "Виртуальная среда",
        "key": "menu_virtual",
        "icon": "icon-screen-desktop",
        "action": "/virtual_env",
        "rules": "rules"
      },
      {
        "name": "События",
        "key": "menu_events",
        "icon": "icon-event",
        "action": "/loginhistory",
        "rules": "rules"
      }
    ]
  },
  {
    "name": "Настройки",
    "key": "menu_admin",
    "icon": "icon-settings",
    "submenu": [
      {
        "name": "Доступы",
        "key": "menu_rules",
        "icon": "icon-note",
        "action": "/rules",
        "rules": "rules"
      },
      {
        "name": "Роли",
        "key": "menu_roles",
        "icon": "icon-grid",
        "action": "/roles",
        "rules": "rules"
      },
      {
        "name": "Сотрудники",
        "key": "menu_sys_users",
        "icon": "icon-people",
        "action": "/sys_users",
        "rules": "rules"
      },
      // {
      //   "name": "История входов",
      //   "key": "menu_login_history",
      //   "icon": "icon-people",
      //   "action": "/loginhistory",
      //   "rules": "rules"
      // }
    ]
  },
]

const MenuItems = (props) => {
  if (props.items === null) return null;
  let v_ret = props.items.map(function (item, index) {
    if ("submenu" in item)
      return (
        <li key={item.key} className="dropdown"><a href="#"><i className={"me-2 " + item.icon}></i>{item.name}</a>
          <ul>
            <MenuItems items={item.submenu} />

          </ul>
        </li>
      );
    else
      return (
        <li key={item.key}><NavLink to={item.action}><i className={"me-2 " + item.icon}></i>{item.name}</NavLink></li>
      );
  });
  return v_ret;
}

const Menu = (props) => {
  return (
    <div className="sidebar pt-0" data-bs-theme={(props.settings.themeColor ?? "light") === "light" ? "light" : "dark"}>
      <div className="site-width">
        <ul id="side-menu" className="sidebar-menu">
          {/* <MenuItems items={props.menu} /> */}
          <MenuItems items={mainMenu} />
        </ul>
      </div>
    </div>
  );
}

export default React.memo(Menu);
